import * as React from 'react';
import { AppBar, Avatar, IconButton, Stack, Toolbar } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MenuIcon from '@mui/icons-material/Menu';

import { useRouter } from '@cvt/routing';

import { AuthContext } from '@modules/Auth/contexts';

import { Logo } from '../Logo';
import { HeaderNav } from './HeaderNav';
import { UserMenu } from './UserMenu';


type Props = {
  onNavigationClickRequest?: () => void;
};

export const Header: React.FC<Props> = ({ onNavigationClickRequest }) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const { user } = React.useContext(AuthContext);
  const router = useRouter();

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        bgcolor: 'background.paper',
        borderBottom: (theme) => `1px solid ${theme.palette.pink[100]}`,
      }}
    >
      <Toolbar disableGutters sx={{ px: 1 }}>
        <IconButton
          color="secondary"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: 'none' } }}
        >
          <MenuIcon />
        </IconButton>
        <Stack direction="row" alignItems="center" justifyContent="space-between" flexGrow={1}>
          <Logo height={40} width="auto" onClick={() => router.home.go()} style={{ cursor: 'pointer' }}/>

          <Stack direction="row" alignItems="center" gap={4} display={{ xs: 'none', sm: 'flex' }}>
            <HeaderNav/>
          </Stack>

          <UserMenu anchorEl={anchorElUser} onCloseRequest={handleCloseUserMenu}>
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar alt={user?.displayName} src={user?.profilePicture || undefined} />
            </IconButton>
          </UserMenu>
        </Stack>
      </Toolbar>
      <Drawer
        container={window.document.body}
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          zIndex: 1201,
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
        }}
      >
        <Box mt={1} textAlign="center" onClick={handleDrawerToggle}>
          <Logo height={40} width="auto" onClick={() => router.home.go()} style={{ cursor: 'pointer' }}/>
          <HeaderNav/>
        </Box>
      </Drawer>
    </AppBar>
  );
};
